export default "__VITE_ASSET__3pZ6TvmD__"